<ng-container *ngIf="shippingModel">
  <div class="row m-t-xl" *ngIf="shippingModel?.billingAddress">
    <div class="col-12">
      <div class="col-8 pull-left">
        <h3>{{ shippingAemContent?.shipping }}</h3>
      </div>
      <div class="col-4 pull-right">
        <ng-content select="[edit]"></ng-content>
      </div>
    </div>
  </div>
  <p *ngIf="backOrderStatus" class="alert-text m-t-lg">
    <i class="fa fa-flag def alert-icon"></i>{{ shippingAemContent?.backOrderItems }}
  </p>
  <div class="row m-t-lg">
    <!-- left-side section starts -->
    <div class="col-12">
      <p class="lead bold">{{ shippingAemContent?.shipTo }}</p>
      <p
        *ngIf="shippingAddress?.middleName && shippingAddress?.middleName !== ''; else noMiddleName"
        class="lead"
      >
        {{ shippingAddress?.firstName }} {{ shippingAddress?.middleName }}
        {{ shippingAddress?.lastName }}
      </p>
      <ng-template #noMiddleName>
        <p class="lead">{{ shippingAddress?.firstName }} {{ shippingAddress?.lastName }}</p>
      </ng-template>
      <p class="lead">{{ shippingAddress?.urbanizationCode }}</p>
      <p class="lead">{{ shippingAddress?.address1 }}</p>
      <p class="lead">{{ shippingAddress?.address2 }}</p>
      <p class="lead">
        {{ shippingAddress?.city }}, {{ shippingAddress?.state }} {{ shippingAddress?.zipCode }}
      </p>
      <p class="lead">{{ shippingModel?.shippingNotification }}</p>
    </div>
    <!-- left-side section ends -->

    <!-- right-side section starts -->
    <div
      class="col-12 m-t-md"
      *ngIf="
        shippingModel?.selectedShippingOption?.optionDisplayName &&
        shippingModel?.selectedShippingOption?.estimatedDeliveryDate
      "
    >
      <p class="lead bold">{{ shippingAemContent?.method }}</p>
      <p class="lead">{{ shippingModel?.selectedShippingOption?.optionDisplayName }}</p>
      <p class="lead bold m-t-md">{{ shippingAemContent?.estimatedDelivery }}</p>
      <p class="lead">{{ shippingModel?.selectedShippingOption?.estimatedDeliveryDate | date }}</p>
    </div>
    <!-- right-side section ends -->
  </div>

  <hr class="divider m-t-xl" />
</ng-container>
